export default "__VITE_ASSET__VTsjekqQ__"